(function () {
  var revealObserver;
  var scrollFrame = 0;

  function setupReveal(root) {
    if (!document.body.dataset.erReveal || document.body.dataset.erMotion === 'off') return;
    if (!('IntersectionObserver' in window)) return;
    if (!revealObserver) {
      revealObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-visible');
          revealObserver.unobserve(entry.target);
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.01 });
    }
    var scope = root || document;
    var revealNodes = Array.prototype.slice.call(scope.querySelectorAll('#MainContent > .shopify-section:not(:first-child), .shopify-section [data-er-reveal-item]'));
    if (scope instanceof Element && scope.matches('#MainContent > .shopify-section:not(:first-child), [data-er-reveal-item]')) revealNodes.push(scope);
    revealNodes.forEach(function (node) {
      if (node.dataset.erRevealReady === 'true') return;
      node.dataset.erRevealReady = 'true';
      node.setAttribute('data-er-reveal', '');
      if (window.Shopify && Shopify.designMode) node.classList.add('is-visible');
      else revealObserver.observe(node);
    });
  }

  function updateScroll() {
    scrollFrame = 0;
    var top = window.scrollY;
    var available = Math.max(document.documentElement.scrollHeight - window.innerHeight, 1);
    var progress = document.querySelector('[data-er-progress] span');
    var backToTop = document.querySelector('[data-er-back-to-top]');
    if (progress) progress.style.transform = 'scaleX(' + Math.min(top / available, 1) + ')';
    if (backToTop) backToTop.classList.toggle('is-visible', top > Math.max(window.innerHeight * 1.4, 900));
  }

  function onScroll() {
    if (scrollFrame) return;
    scrollFrame = window.requestAnimationFrame(updateScroll);
  }

  function initJourney(root) {
    var scope = root || document;
    scope.querySelectorAll('[data-er-journey]').forEach(function (journey) {
      if (journey.dataset.ready === 'true') return;
      journey.dataset.ready = 'true';
      var links = Array.prototype.slice.call(journey.querySelectorAll('a[href^="#"]'));
      var targets = links.map(function (link) { return document.querySelector(link.getAttribute('href')); }).filter(Boolean);
      if (!targets.length || !('IntersectionObserver' in window)) return;
      var observer = new IntersectionObserver(function (entries) {
        var visible = entries.filter(function (entry) { return entry.isIntersecting; }).sort(function (a, b) { return b.intersectionRatio - a.intersectionRatio; })[0];
        if (!visible) return;
        links.forEach(function (link) {
          var active = link.getAttribute('href') === '#' + visible.target.id;
          link.classList.toggle('is-active', active);
          if (active) {
            var left = link.offsetLeft - ((journey.clientWidth - link.offsetWidth) / 2);
            journey.scrollTo({ left: Math.max(left, 0), behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
          }
        });
      }, { rootMargin: '-28% 0px -58% 0px', threshold: [0, .05, .2] });
      targets.forEach(function (target) { observer.observe(target); });
    });
  }

  function init(root) {
    setupReveal(root);
    initJourney(root);
    updateScroll();
  }

  document.addEventListener('click', function (event) {
    if (!event.target.closest('[data-er-back-to-top]')) return;
    window.scrollTo({ top: 0, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
  });
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
  document.addEventListener('shopify:section:select', function (event) {
    event.target.querySelectorAll('[data-er-reveal]').forEach(function (node) { node.classList.add('is-visible'); });
  });
})();
